/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";

const Header = ({ act }) => {
  const [totales, setTotales] = useState([]);

  const obtenertotales = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/obtenertotales/`
      );
      if (!response.ok) {
        throw new Error("Error en la red");
      }
      const data = await response.json();
      if (data) {
        console.log(data);
        setTotales(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const obtenervalor = (label) => {
    if (label == "galeria") {
      if (totales.galeria) {
        return totales.galeria;
      } else {
        return 0;
      }
    }

    if (label == "eventos") {
      if (totales.eventos) {
        return totales.eventos;
      } else {
        return 0;
      }
    }

    if (label == "predicas") {
      if (totales.predicas) {
        return totales.predicas;
      } else {
        return 0;
      }
    }

    if (label == "books") {
      if (totales.books) {
        return totales.books;
      } else {
        return 0;
      }
    }
  };

  const cargarpage = (site) => {
    window.location.href = site;
    window.location.reload();
  };

  useEffect(() => {
    obtenertotales();
  }, []);

  useEffect(() => {
    console.log(totales);
  }, [totales]);

  useEffect(() => {
    obtenertotales();
  }, [act]);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Eventos
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {obtenervalor("eventos")}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fas fa-calendar-days" />
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <Link to="/admin/eventos">
                      <Button
                        color="primary"
                        size="sm"
                        style={{ width: "100%" }}
                      >
                        Administrar
                      </Button>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Predicas
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {obtenervalor("predicas")}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-microphone" />
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <Link to="/admin/predicas">
                      <Button
                        color="primary"
                        size="sm"
                        style={{ width: "100%" }}
                      >
                        Administrar
                      </Button>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Libros
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {obtenervalor("books")}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                          <i className="fas fa-book" />
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <Link to="/admin/books">
                      <Button
                        color="primary"
                        size="sm"
                        style={{ width: "100%" }}
                      >
                        Administrar
                      </Button>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Galeria
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {obtenervalor("galeria")}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fas fa-camera" />
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <Link to="/admin/galeria">
                      <Button
                        color="primary"
                        size="sm"
                        style={{ width: "100%" }}
                      >
                        Administrar
                      </Button>
                    </Link>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
